export default __webpack_public_path__ + "7be1944ab57541e03c04a608bd8b11bd.svg";